import { createReducer } from 'redux-act';
import { StateStatus } from '@alycecom/utils';

import { IBranding } from '../../types/Branding.types';
import { defaultBrandingColors } from '../../constants/branding.constants';
import { getBrandingColor } from '../../helpers/branding.helpers';

import { applyBranding, fetchBranding } from './branding.actions';

export interface IBrandingState {
  status: StateStatus;
  data: IBranding;
}

export const initialState: IBrandingState = {
  status: StateStatus.Idle,
  data: {
    ...defaultBrandingColors,
    backgroundSize: null,
    backgroundImageUrl: null,
    backgroundImageId: 0,
    logoUrl: '',
    logoId: 0,
    messageHeader: '',
    termsUrl: '',
    privacyPolicyLink: '',
    contactSupportLink: '',
    disclaimer: '',
    companyName: '',
    giftCardConfirmationMessaging: '',
  },
};

export const branding = createReducer<IBrandingState>({}, initialState);

branding
  .on(fetchBranding.pending, state => ({
    ...state,
    status: StateStatus.Pending,
  }))
  .on(fetchBranding.fulfilled, (state, payload) => ({
    ...state,
    status: StateStatus.Fulfilled,
    data: {
      ...payload,
      backgroundColor: getBrandingColor(payload.backgroundColor, defaultBrandingColors.backgroundColor),
      primaryColor: getBrandingColor(payload.primaryColor, defaultBrandingColors.primaryColor),
      secondaryColor: getBrandingColor(payload.secondaryColor, defaultBrandingColors.secondaryColor),
      tertiaryColor: getBrandingColor(payload.tertiaryColor, defaultBrandingColors.tertiaryColor),
      highlightColor: getBrandingColor(payload.highlightColor, defaultBrandingColors.highlightColor),
      headlineColor: getBrandingColor(payload.headlineColor, defaultBrandingColors.headlineColor),
      primaryCtaColor: getBrandingColor(payload.primaryCtaColor, defaultBrandingColors.primaryCtaColor),
      secondaryCtaColor: getBrandingColor(payload.secondaryCtaColor, defaultBrandingColors.secondaryCtaColor),
      termsUrl: payload.termsUrl || '',
      privacyPolicyLink: payload.privacyPolicyLink || '',
      contactSupportLink: payload.contactSupportLink || '',
      disclaimer: payload.disclaimer || '',
      companyName: payload.companyName || '',
      giftCardConfirmationMessaging: payload.giftCardConfirmationMessaging || '',
    },
  }))
  .on(fetchBranding.rejected, state => ({
    ...state,
    status: StateStatus.Rejected,
  }));

branding.on(applyBranding, (state, payload) => ({
  ...state,
  data: {
    ...state.data,
    ...payload,
    termsUrl: payload.termsUrl || '',
  },
}));
